export const mapRogoDevTypeToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const rogoDevTypeColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "devTypeCode", label: "DevTypeCode", align: "center" },
  { key: "devTypeStr", label: "DevTypeStr", align: "center" },
];
